import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import { useEffect, useRef, useState } from 'react';


export default function Login() {
  const URL = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const { register, handleSubmit, formState: { errors } } = useForm();

  const emailRef = useRef(null);
  const [hasTypedEmail, setHasTypedEmail] = useState(false);
  const [hasTypedPassword, setHasTypedPassword] = useState(false);  
  const [serverError, setServerError] = useState('');


  useEffect(() => {
    // Automatically focus on email input on page load
    emailRef.current?.focus();
  }, []);

  const handleLogin = async (data) => {
    try {      
      const res = await axios.post(`${URL}/auth/login`, data, { withCredentials: true });  
      if (res.data && res.data.email) {
        sessionStorage.setItem('email', res.data.email);
        axios.defaults.withCredentials = true;        
        navigate('/panel');
      } else {
        const msg = 'ข้อมูลการตอบกลับไม่ถูกต้อง';        
        toast.error(msg);
      }
    } catch (err) {
      const resp = err?.response?.data;
      let msg = 'อีเมลหรือรหัสผ่านไม่ถูกต้อง!';
      if (resp) {
        if (Array.isArray(resp.errors)) msg = resp.errors.map(e => e.msg).join(', ');
        else if (resp.message) msg = resp.message;
        else if (resp.error) msg = resp.error;
      }

      // show toast and also set inline fallback so user sees it even if toast fails      
      setServerError(msg);
      try { toast.error(msg); } catch (tErr) { }

      // Automatically clear inline error after a few seconds      
    }
  };

  useEffect(() => {
    if (!serverError) return;
    const id = setTimeout(() => setServerError(''), 5000);
    return () => clearTimeout(id);
  }, [serverError]);

  return (
    <section className="min-h-screen bg-gray-200 flex items-center justify-center">
      
      <div className="max-w-4xl w-full h-[480px] bg-white rounded-lg overflow-hidden shadow-lg flex flex-col md:flex-row">
        {/* Left - Image */}
        <div className="hidden md:block md:w-1/2">
          <img
            src="/login.png"
            alt="login"
            className="h-full w-full object-cover rounded-l-lg"
          />
        </div>

        {/* Right - Login Form */}
        <div className="w-full md:w-1/2 p-8 flex flex-col justify-center">
          <div className="mb-4 flex justify-center md:justify-start">
            <a href="/">
              <img src="/logo.png" alt="AI Business Technology Co., Ltd." className="h-10 w-auto mb-6" />
            </a>
          </div>

          <h2 className="text-xl font-semibold mb-4 text-center md:text-left">
            บริษัท เอไอ บิสซิเนส เทคโนโลยี จำกัด
          </h2>

          <form onSubmit={handleSubmit(handleLogin)} noValidate>
            <div className="mb-3">
              <label htmlFor="email" className="block text-gray-700 mb-1">Email address</label>
              <input
                id="email"
                type="email"
                {...register('email', { 
                  required: 'กรุณาระบุอีเมล', 
                  pattern: { 
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, 
                    message: 'รูปแบบอีเมลไม่ถูกต้อง' 
                  } 
                })}
                
                ref={(e) => {
                  register('email').ref(e);
                  emailRef.current = e;
                }}
                onChange={(e) => {
                  setHasTypedEmail(true);                  
                }}
                placeholder={
                  hasTypedEmail ? '' :
                  errors.email ? errors.email.message : ''
                }
                className={`w-full px-4 py-2 border rounded-lg focus:outline-none
                  ${errors.email && !hasTypedEmail
                    ? 'border-red-500 text-red-500 placeholder-red-400'
                    : 'border-gray-300 text-black placeholder-gray-400'}
                `}
              />
            </div>

            <div className="mb-4">
              <label htmlFor="password" className="block text-gray-700 mb-1">Password</label>
              <input
                id="password"
                type="password"
                {...register('password', { required: 'กรุณาระบุรหัสผ่าน' })}
                onChange={(e) => {
                  setHasTypedPassword(true);                  
                }}
                placeholder={
                  hasTypedPassword ? '' :
                  errors.password ? errors.password.message : ''
                }                
                className={`w-full px-4 py-2 border rounded-lg focus:outline-none
                  ${errors.password && !hasTypedPassword
                    ? 'border-red-500 text-red-500 placeholder-red-400'
                    : 'border-gray-300 text-black placeholder-gray-400'}
                `}
              />

            </div>

            <button
              type="submit"
              className="w-full bg-blue-900 text-white py-2 rounded-lg hover:bg-blue-800 transition duration-200"
            >
              เข้าสู่ระบบ
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}